import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=88cd9e0a&scoped=true&"
import script from "./Test.vue?vue&type=script&lang=js&"
export * from "./Test.vue?vue&type=script&lang=js&"
import style0 from "./Test.vue?vue&type=style&index=0&id=88cd9e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cd9e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88cd9e0a')) {
      api.createRecord('88cd9e0a', component.options)
    } else {
      api.reload('88cd9e0a', component.options)
    }
    module.hot.accept("./Test.vue?vue&type=template&id=88cd9e0a&scoped=true&", function () {
      api.rerender('88cd9e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/Test.vue"
export default component.exports